// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["_rbenv_versions_3_0_2_lib_ruby_gems_3_0_0_gems_decidim-forms-0_27_5_app_packs_src_decidim_for-37f2bb"], function() { return __webpack_require__("../../../.rbenv/versions/3.0.2/lib/ruby/gems/3.0.0/gems/decidim-forms-0.27.5/app/packs/entrypoints/decidim_forms.js"); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
